// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---node-modules-arshad-gatsby-theme-page-core-src-templates-page-query-js": () => import("./../node_modules/@arshad/gatsby-theme-page-core/src/templates/page-query.js" /* webpackChunkName: "component---node-modules-arshad-gatsby-theme-page-core-src-templates-page-query-js" */)
}

